import http from '@/components/services/http-common';
import formatter from '@/components/services/formatter';

export const get = (hasQuit) => http.get("employees/by-rm").then(r =>{
  r.data.data = r.data.data.filter(f => hasQuit ? true : f.status != 'Nghỉ Việc').map(x => {
      x.birthDay = formatter.formatDate(x.birthDay)
      x.hireDate = formatter.formatDate(x.hireDate)
    return x
  })

  return r.data
})
